import {css} from '../utils.js';

const styles = css`
    .ddk-container .layout-tag-container {
        display: flex;
        flex-direction: row;
        width: fit-content;
        align-items: center;
        gap: 6px;
        padding: ${props =>
            props.theme.tag_padding ??
            'var(--ddk-padding-2xs) var(--ddk-padding-xs)'};
        background: ${props =>
            props.theme.tag_background_color ??
            'var(--ddk-surface-surface-secondary, #F1F1F1)'};
        color: ${props =>
            props.theme.tag_text ?? 'var(--ddk-text-text-secondary, #646464)'};
        font-size: ${props =>
            props.theme.tag_font_size ?? 'var(--ddk-font-size-sm)'};
        border-style: ${props => props.theme.tag_border?.style ?? 'solid'};
        border-width: ${props => props.theme.tag_border?.width ?? '1px'};
        border-color: ${props =>
            props.theme.tag_border?.color ?? 'var(--ddk-border-base-tertiary)'};
        border-radius: ${props =>
            props.theme.tag_border?.radius ?? 'var(--ddk-radius-sm)'};
    }

    .ddk-container .layout-tag-container p {
        margin: 0px;
    }
`;

export default styles;
